import { loadModules } from 'esri-loader';
import { ILayerObject } from './../types/layers';

/**
 * A function that handles the generation of Esri Layers
 * @param layer - the configuration settings for the layer to be created
 */
export default async (layer: ILayerObject) => {
  const [FeatureLayer, ImageryLayer, ImageryTileLayer, MapImageLayer, VectorTileLayer, TileLayer, PopupTemplate] = await loadModules([
    'esri/layers/FeatureLayer',
    'esri/layers/ImageryLayer',
    'esri/layers/ImageryTileLayer',
    'esri/layers/MapImageLayer',
    'esri/layers/VectorTileLayer',
    'esri/layers/TileLayer',
    'esri/PopupTemplate'
  ]);

  
  let itemInfoResponse;
  let itemInfo;

  try {
    itemInfoResponse = await fetch(layer.options.portalUrl);
    itemInfo= await itemInfoResponse.json();
  } catch (e) {
    console.error(e);
  }

  if (itemInfoResponse) {
    let esriLayer = null;
    
    switch (layer.type) {
      case 'FeatureLayer':
        esriLayer = new FeatureLayer(layer.options);
        break;
      case 'ImageryLayer':
        esriLayer = new ImageryLayer(layer.options);
        break;
      case 'ImageryTileLayer':
        esriLayer = new ImageryTileLayer(layer.options);
        break;
      case 'MapImageLayer':
        esriLayer = new MapImageLayer(layer.options);
        break;
      case 'VectorTileLayer':
        esriLayer = new VectorTileLayer(layer.options);
        break;
      case 'TileLayer':
        esriLayer = new TileLayer(layer.options);
        break;
      default:
        console.warn('No matching layer type for layer', layer);
    }

    esriLayer.when((l: any) => {
      switch(l.id) {
        case 'historical-plantations':
        case 'natura-2000':
          const featsSublayer = l.findSublayerById(0)
          featsSublayer.load();
          featsSublayer.popupEnabled = true;
          featsSublayer.popupTemplate = new PopupTemplate({ ...layer.options.popupTemplate  });
          break;
        default:
          break;
      }
      
    });
    
    esriLayer.description = itemInfo ? itemInfo.description : '';
    
    return esriLayer;
  } else {
    return null;
  }
};


